export const OrderStatus = Object.freeze({
  CONFIRMED: 'confirmed',
  COMPLETED: 'completed',
  ACK: 'acknowledged',
  ACKNOWLEDGED: 'ORDER_PLACED',
  ORDER_CREATED: 'ORDER_CREATED',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  PAYMENT_CONFIRMED: 'PAYMENT_CONFIRMED',
  ACCEPTED_BY_RESTAURANT: 'ORDER_ACCEPTED',
  ACCEPTED_BY_DP: 'ACCEPTED_BY_DELIVERY_PARTNER',
  PREPARING_ORDER: 'ORDER_IN_PROCESS',
  READY_FOR_DISPATCH: 'READY_FOR_DISPATCH',
  ORDER_PICKED_UP: 'ORDER_DISPATCHED',
  DELIVERED: 'ORDER_DELIVERED',
  CANCELLED_BY_RESTAURANT: 'ORDER_CANCELLED',
  CANCELLED_BY_DP: 'CANCELLED_BY_DELIVERY_PARTNER',
  CANCELLED: 'USER_CANCELLED',
  ORDER_COMPLETED: 'ORDER_COMPLETED',
  WAITING: 'Waiting for delivery partner to accept the order',
});

export const PaymentMode = Object.freeze({
  ONLINE: 'online',
  CASH: 'cash',
});
export const PaymentStatus = Object.freeze({
  PENDING: 'pending',
  PAID: 'paid',
});

export const OrderType = Object.freeze({
  DELIVERY: 'delivery',
  TAKEAWAY: 'takeaway',
  DINEIN: 'dinein',
  INROOMDINEIN: 'irdining',
  TABLERES: 'tableRes',
});
export const OrderTypeLabel = Object.freeze({
  DELIVERY: 'Delivery',
  TAKEAWAY: 'Takeaway',
  DINEIN: 'Dine in',
  INROOMDINEIN: 'In Room Dining',
  TABLERES: 'Table Reservation',
});
export const Color = Object.freeze({
  defaultColor: '#EE2F37',
});
export const ChargeTypes = Object.freeze({
  FIXED: 'fixed',
  PERCENTAGE: 'percentage',
});

export const DeliveryPartner = Object.freeze({
  SELF_DELIVERY: 'self_delivery',
});

export const filterType = Object.freeze({
  FOOD: 'Food',
  BAR: 'Bar',
  VEG: 'Veg',
  NONVEG: 'Non-Veg',
  EGG: 'Egg',
});
export const paymentStatus = Object.freeze({
  PENDING: 'pending',
  PAID: 'paid',
  REFUNDED: 'refunded',
});
export const routeNames = Object.freeze({
  DASHBOARDName: 'Dashboard',
  PASTORDERName: 'Past Orders',
  OFFERSName: 'Offers',
  INVENTORYName: 'Inventory',
  SETTINGS: 'Settings',
});
export const refundStatusMsg = Object.freeze({
  SUCCESS: 'Refund initiated for order',
  FAILURE:
    'Refund could not be completed. Please trigger refund manually from razorpay dashboard',
});

export const OfferTypes = Object.freeze({
  FLAT: 'flat_discount',
  PERCENT: 'percent',
  FREEDELIVERY: 'free_delivery',
});

export const DiscountTypes = Object.freeze({
  ORDERLVL: 'order_level',
  ITEMLVL: 'item_level',
});

export const defaultWaitingTimeForResendOTP = 30;


export const reCAPTCHA_site_key = "6LfjjmAbAAAAANYlUbGeHcvsp6r-kr7cX5-NIRXO";

export const RESTAURANT_TYPE = {
  BRAND: 'brand',
  OUTLET: 'outlet',
};


export const FulfillmentTime = [
  '11:00-13:00',
  '13:00-15:00',
  '15:00-17:00',
  '17:00-19:00',
];

export const bankStructure = Object.freeze({
  "name": "",
  "bank_details": {
      "account_type": "bank_account",
              "bank_account": {
                      "account_number": "",
                      "ifsc": "",
                      "name": ""
              }
  }
})

export const upiStructure = Object.freeze({
  "name": "",
  "upi_details": {
          "account_type": "vpa",
          "vpa": {
              "address": ""
          }
      }
})

